var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.text)?_c('img',{staticClass:"mt-6 mb-2 rounded border",attrs:{"src":_vm.qrcode,"alt":"QR Code"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }